<template>
    <div v-if="shouldShowItems" class="container">
        <div class="col-md-12">
            <div class="row">
                <h2 v-if="title" class="col-md-8 col-xs-12 title-pagination text-uppercase">{{ title }}</h2>
                <a v-if="linkTitle"
                   :href="linkAll"
                   class="link-all col-md-4 col-xs-12 text-right text-uppercase panel-title">
                    {{linkTitle}}
                </a>
            </div>
        </div>
        <div class="themes-thumbnails col-sm-12">
            <div class="row">
                <horizontal-data-list-component
                        ref="data_list"
                        :data-source="paginateUrl"
                        class="horizontal-data-list-component">
                    <template slot-scope="slotData">
                        <loader :show-loader="slotData.loading"></loader>
                        <transition-group v-show="!slotData.loading" name="list">
                            <div v-for="(item, index) in slotData.items" :key="item.id"
                                 class="col-md-4 col-sm-4 col-xs-12 card-content w-32 mt-10">
                                <card-horizontal
                                        :is-pagination="true"
                                        :custom-class="customClass"
                                        :bundle="item">
                                </card-horizontal>
                            </div>
                        </transition-group>

                    </template>
                </horizontal-data-list-component>
            </div>
        </div>
    </div>
</template>

<script>
  import CardHorizontal from './CardHorizontal.vue';

  export default {
    name: 'horizontal-pagination',

    components: {
      'card-horizontal': CardHorizontal,
    },

    props: {
      title: {
          type: String,
          required: false,
      },
      linkAll: {
        type: String,
        required: false,
      },
      linkTitle: {
        type: String,
        required: false,
      },

      customClass: {
        required: false,
      },
      paginateUrl: String,
    },

    mounted() {
      this.$on('shouldShowItems', (payload) => {
        this.shouldShowItems = payload > 0;
      });
    },

    data() {
      return {
        items: [],
        shouldShowItems: true,
      };
    },
  };
</script>

<style scoped>
    .container {
        padding: 30px 0 0 0;
    }

    .link-all {
        color: #374853;
        font-family: Montserrat;
    }

    .title-pagination {
        color: #374853;
        font-size: 18px;
        font-weight: 100;
        padding: 0;
        margin: 0;
    }

    .list-enter-active {
        display: none;
    }

    .list-enter-active, .list-leave-active {
        transition: all 0.5s;
    }

    .list-enter, .list-leave-to {
        opacity: 0;
        transform: translateX(30px);
    }

    .themes-thumbnails {
        padding: 0;
    }

    .pl-22{
        padding-left: 22px;
    }

    .pr-22{
        padding-right: 22px;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/store/components/HorizontalPagination.vue